import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';
import RightsForm from '../RightsForm';
// import EditCompanyForm from "../../components/EditCompanyForm";

const RightsModal = ({
  visible,
  onClose,
  data,
  submitEditForm,
  error = null,
  title,
}: {
  visible: any;
  onClose: any;
  data: any;
  submitEditForm: any;
  error?: any;
  title: any;
}) => {
  const [submit, setSubmit] = useState(false);
  const [reset, setReset] = useState(false);

  const formSubmit = (values) => {
    const _id = data ? data?.id : undefined;
    submitEditForm(_id, values);
    setSubmit(false);
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <RightsForm
            submitOutside={submit}
            formProps={data || {}}
            error={error}
            reset={reset}
            resetConfirm={() => setReset(false)}
            submit={formSubmit}
          />
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            variant="outline"
            data-testid="rights-modal-close-btn"
            onClick={() => onClose()}
          >
            Zavřít
          </Button>
          <Button key={2} data-testid="rights-modal-confirm-btn" onClick={() => setSubmit(true)}>
            Potvrdit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RightsModal;
